(() => {
  if (window.sjCommerceEventsReady) return;
  window.sjCommerceEventsReady = true;

  const push = (eventName, details = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      page_path: window.location.pathname,
      page_language: document.documentElement.lang || 'en',
      ...details
    });
    if (typeof window.clarity === 'function') window.clarity('event', eventName);
  };

  const productHandle = (url) => {
    try {
      const match = new URL(url, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    } catch (error) {
      return '';
    }
  };

  push('sj_landing_view', { page_type: document.body?.className || '' });

  document.addEventListener('click', (event) => {
    const productLink = event.target.closest('a[href*="/products/"]');
    if (productLink) {
      push('select_item', {
        item_handle: productHandle(productLink.href),
        item_list_name: productLink.closest('[data-section-type], section, .shopify-section')?.id || 'storefront'
      });
    }

    const checkout = event.target.closest('[name="checkout"], .shopify-payment-button__button, a[href*="/checkout"]');
    if (checkout) push('begin_checkout');

    const addButton = event.target.closest('[name="add"], [data-add-to-cart], [data-product-add]');
    if (addButton && !addButton.closest('form[action*="/cart/add"]')) {
      push('add_to_cart', { interaction: 'button' });
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    const variant = form.querySelector('[name="id"]')?.value || '';
    push('add_to_cart', { item_variant: variant, interaction: 'form' });
  }, true);
})();
